import { omit } from 'lodash';

import instanceEvents from './utils/instanceEvents';

export default function withTTS() {
  return Component => ({
    name: `${Component.name}-with-TTS`,
    props: {
      ...omit(Component.props, ['playbackError']),
    },
    data() {
      return {
        state: {
          playbackError: null,
        },
      };
    },
    methods: {
      // eslint-disable-next-line no-unused-vars
      play(text, voiceId) {
        // playText(text, voiceId);
        // This used to call the polly provider which was calling AWS directly from
        // the client.  That was bad because it exposed the AWS key.  We had to push
        // a hotfix to get rid of that.  TODO: Remove this file, and the ChattyKathy
        // dependency
      },
    },
    render(createElement) {
      return createElement(
        Component,
        {
          props: {
            ...this.$props,
            playbackError: this.state.playbackError,
          },
          on: {
            ...instanceEvents(this),
            tts: this.play,
          },
        },
        this.$slots.default,
      );
    },
  });
}
